import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'

import { useParticipateStore } from '@/stores/ParticipateStore.js'
import { useSettingsStore } from '@/stores/SettingsStore.js'

const storeID = 'TableStore'

const newTable = () => ({
    name: '',
    participates: [],
    number: 0,
    uuid: uuidv4()
})

export const useTableStore = defineStore(storeID, {
    state: () => ({
        tables: []
    }),
    getters: {
        assignedParticipateIds(state) {
            const ids = new Set()
            state.tables.forEach(table => {
                table.participates.forEach(id => ids.add(id))
            })
            return ids
        }
    },
    persist: true,
    actions: {
        get(id) {
            return this.tables.find(table => table.uuid === id)
        },
        assign(tableID, participateIDs) {
            let table = this.get(tableID)

            if (! table) {
                table = newTable()
                this.tables.push(table)
            }

            participateIDs.forEach((participateID) => {
                if(! table.participates.find(participate => participate === participateID)) {
                    table.participates.push(participateID)
                }
            })
        },
        setParticipants(tableId, participateIds) {
            const table = this.get(tableId)
            if (table) {
                table.participates = participateIds
            }
        },
        move(tableID, participateID) {
            this.tables.forEach((table) => {
                table.participates.forEach((tableParticipateID, i) => {
                    if (tableParticipateID === participateID) {
                        table.participates.splice(i, 1)
                    }
                })
            })

            let table = this.get(tableID)
            if(! table.participates.find(participate => participate === participateID)) {
                table.participates.push(participateID)
            }
        },
        createNewTable() {
            this.tables.push(newTable())
        },
        rename(tableId, name) {
            const table = this.get(tableId)
            if (table) {
                table.name = name
            }
        },
        createNewTableIdNeeded() {
            let participateStore = useParticipateStore()
            let settingsStore = useSettingsStore()

            let additionalTablesNeeded = Math.ceil(participateStore.participates.length / settingsStore.tableSize) - this.tables.length
            if (additionalTablesNeeded > 0) {
                while(this.tables.length < Math.ceil(participateStore.participates.length / settingsStore.tableSize)) {
                    this.createNewTable()
                }
            }
        },
        removeUnusedTables() {
            this.tables = this.tables.filter(table => table.participates.length > 0)
        },
        remove(id) {
            this.tables.forEach((table, i) => {
                if (table.uuid === id) {
                    this.tables.splice(i, 1)
                }
            })
        },
        reset() {
            this.tables = []
        }
    }
})
